import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PrivateRoute() {
    const { t } = useTranslation();
    const [authorized, setAuthorized] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem('token');
        setAuthorized(!!token);
    }, []);

    if (authorized === null) {
        return (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: '50px',
                    fontSize: '18px',
                    fontWeight: '500',
                }}
            >
                {t('checking_login')}
            </div>
        );
    }

    return authorized ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
}

export default PrivateRoute;
